/*
 * External libraries to be pulled in as script tags for CDN usage.
 * After all javascript files are loaded, run the application.
 */
// import './polyfills'; // Load any needed polyfills first!
// eslint-disable-next-line no-unused-expressions
module?.hot?.accept(); // Enable HMR if module.hot is available.
import appendToHead, {
    promiseAppendToHead,
} from '@corefact/toolchain/helpers/appendToHead';
import removeElement from '@corefact/toolchain/helpers/removeElement';

import CDN from './configs/cdn-settings';

window.ErrorReporter = {
    ...console,
    ...{
        warning: (...args) => console.warn.apply(console, args),
        critical: (...args) => console.error.apply(console, args),
    },
};

let css = CDN.stylesheets || { enabled: false };
if (css.enabled && Array.isArray(css.sheets)) {
    css.sheets.forEach((sheet) => {
        if (sheet.enabled == false) return removeElement(sheet, 'link');
        if (sheet.enabledIf instanceof Function)
            return sheet.enabledIf() ? appendToHead(sheet, 'link') : false;
        appendToHead(sheet, 'link');
    });
}

let js = CDN.javascripts || { enabled: false };
if (js.enabled && Array.isArray(js.scripts)) {
    let removeReturnScript = (script) => removeElement(script) && script;
    js.scripts
        .reduce((p, script) => {
            return p
                .then(() => {
                    if (script.enabled === false)
                        return Promise.reject(removeReturnScript(script));
                    if (script.enabledIf instanceof Function)
                        return script.enabledIf()
                            ? script.waitFor
                                ? promiseAppendToHead(script)
                                : Promise.resolve(appendToHead(script))
                            : Promise.reject(script);
                    return script.waitFor
                        ? promiseAppendToHead(script)
                        : Promise.resolve(appendToHead(script));
                })
                .catch(() => Promise.resolve());
        }, Promise.resolve())
        .then(() => import('./application'));
}
